'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scheduleFunctionOnLazyInterval = scheduleFunctionOnLazyInterval;
var MIN_POLL_INTERVAL = 1000;
var hasRequestIdleCallback = window.requestIdleCallback;

var lazyCheck = hasRequestIdleCallback ? function (func) {
  return requestIdleCallback(func);
} : function (func) {
  return func();
};

function scheduleFunctionOnLazyInterval(jobFunc, timeout) {
  var wrappedFunc = function wrappedFunc() {
    lazyCheck(function () {
      jobFunc();
      setTimeout(wrappedFunc, timeout);
    });
  };

  setTimeout(wrappedFunc, timeout);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-3.28/js/util/schedule.js
// module id = 549
// module chunks = 0